module.exports = __webpack_public_path__ + "img/why1.6a2b8d6d.jpg";